export const formatTime = (timeDiff: number) => {
  const daysRemaining = Math.floor(timeDiff / 1000 / 60 / 60 / 24);
  const hoursRemaining = Math.floor(timeDiff / 1000 / 60 / 60);
  const minutesRemaining = Math.floor(timeDiff / 1000 / 60);

  let timeRemaining = minutesRemaining;
  let unit = "minute";

  if (daysRemaining >= 1) {
    timeRemaining = daysRemaining;
    unit = "day";
  } else if (hoursRemaining >= 1) {
    timeRemaining = hoursRemaining;
    unit = "hour";
  }
  if (timeRemaining > 1) unit += "s";
  return `${timeRemaining} ${unit}`;
};

export const formatRefreshTime = (timeDiff: number) => {
  const daysRemaining = Math.floor(timeDiff / 1000 / 60 / 60 / 24);
  const hoursRemaining = Math.floor(timeDiff / 1000 / 60 / 60);
  const minutesRemaining = Math.floor(timeDiff / 1000 / 60);

  let timeRemaining = minutesRemaining;
  let unit = "minute";

  if (daysRemaining === 7) return "weekly";
  else if (hoursRemaining === 24) return "daily";
  else if (daysRemaining >= 1) {
    timeRemaining = daysRemaining;
    unit = "days";
  } else if (hoursRemaining >= 1) {
    timeRemaining = hoursRemaining;
    unit = "hours";
  }

  return `every ${timeRemaining} ${unit}`;
};
